import {useTranslation} from "react-i18next";
import useModal from "../../../../Hooks/useModal";
import Spinner from "../../../Fundamentals/Spinner/Spinner";
import React, {useEffect, useState} from "react";
import {SkynetAnchor} from "../../../Fundamentals/Anchor/SkynetAnchor";
import Modals from "../../../../Constants/modals";
import LicenseTerminationModal from "../../../Modals/LicenseTermination/LicenseTerminationModal";
import ExpandableTable from "../../../Fundamentals/Tables/ExpandedableTable";
import Tooltip, {TooltipContent, TooltipTrigger} from "../../../Overlays/Tooltip";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import customerRoutes from "../../../../Constants/Customer/customerRoutes";

export const Licenses = ({  subscription, subscriptionLicenses, blockEdit }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { isModalOpen, openModal } = useModal();
    const [selectedLicense, setSelectedLicense] = useState(null);
    const customer = useSelector((state) => state.CustomerReducer.customer);
    const onTerminate = (license) => {
        setSelectedLicense(license);
        openModal(Modals.LicenseTermination);
    }

    if (!subscriptionLicenses)
        return <Spinner />;
    
    const getTerminationTooltip = (license) => {
        if (license.assignedUser) {
            return t('editsubscriptioncontainer.assignedUserTooltip');
        }
        if (license.termination) {
            return t('editsubscriptioncontainer.alreadyTerminatedTooltip');
        }
        
        return t('editsubscriptioncontainer.includedQuantityTooltip');
    }
    
    return <><div>
        <h3 className="mt-24">{t('subscriptions.licenses')}</h3>
        <ExpandableTable>
            <thead>
                <tr>
                    <th>{t('subscriptions.product')}</th>
                    <th>{t('subscriptions.currentQuantity')}</th>
                    <th>{t('subscriptions.includedQuantity')}</th>
                    <th>{t('subscriptions.maxQuantity')}</th>
                </tr>
            </thead>
            <ExpandableTable.Body>
            {subscriptionLicenses.map((subscriptionProductLicenses) => (
                <ExpandableTable.Row key={subscriptionProductLicenses.product?.id}>
                    <ExpandableTable.Row.Expandable>
                    <td>{`${subscriptionProductLicenses.product?.name} (${subscriptionProductLicenses.product?.externalId}/${subscriptionProductLicenses.product?.articleNumber})`}</td>
                    <td>{subscriptionProductLicenses.currentQuantity}</td>
                    <td>{subscriptionProductLicenses.includedQuantity}</td>
                    <td>{subscriptionProductLicenses.maxQuantity}</td>
                    </ExpandableTable.Row.Expandable>
                    <ExpandableTable.Row.Expanded>
                        <tr>
                            <td colSpan={3} className="bold">{t('subscriptions.user')}</td>
                            <td width={200} className="text-center"></td>
                        </tr>
                        {subscriptionProductLicenses.licenses?.map((license) => (
                            <tr key={license.id}>
                                <td className="pl-128" colSpan={3} onClick={license.assignedUser ? () => navigate(customerRoutes.customer(customer.pathId, customerRoutes.EditUser(license.assignedUser?.customerUserId))) : undefined}>{license.assignedUser ? `${license.assignedUser?.name} (${license.assignedUser?.email})` : t('subscriptions.notAssigned')}</td>
                                <td width={200} className="text-center">
                                    {license.allowTermination ? (
                                        <SkynetAnchor disabled={blockEdit} onClick={() => onTerminate(license)}>{t('activesubscriptionproductgroups.terminateproductgroup')}</SkynetAnchor>
                                    ) : (
                                        <Tooltip>
                                            <TooltipTrigger>
                                                <SkynetAnchor disabled={true}>
                                                    {t('common.cancel')}
                                                </SkynetAnchor>
                                            </TooltipTrigger>
                                            <TooltipContent>
                                                {getTerminationTooltip(license)}
                                            </TooltipContent>
                                        </Tooltip>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </ExpandableTable.Row.Expanded>
                </ExpandableTable.Row>
            ))}
            </ExpandableTable.Body>
        </ExpandableTable>
    </div>
        {isModalOpen(Modals.LicenseTermination) && (
            <LicenseTerminationModal subscription={subscription} license={selectedLicense} />
        )}</>
}